import viewBsnView from './viewBsnView.js';

const editBsnView = {
	init: function () {
		viewBsnView.init();
	},
};

export default editBsnView;
